import React, { useEffect, useState } from "react";

import CircularProgress from "@mui/material/CircularProgress";

const FullLogoBranco = "/full-logo-branco.png";
import { isPWAStandalone } from "@/utils/environment.utils";

const SPLASH_KEY = "t2b_splash_shown";

const AppSplashScreen: React.FC = () => {
  const [visible, setVisible] = useState(() => {
    if (!isPWAStandalone()) return false;
    if (sessionStorage.getItem(SPLASH_KEY)) return false;
    return true;
  });
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (!visible) return;
    sessionStorage.setItem(SPLASH_KEY, "1");

    const fadeTimer = setTimeout(() => setFading(true), 1500);
    const removeTimer = setTimeout(() => setVisible(false), 2000);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#16d3d9",
        transition: "opacity 0.5s ease-out",
        opacity: fading ? 0 : 1,
        gap: 32,
      }}
    >
      <img
        src={FullLogoBranco}
        alt="Talk2Buy"
        style={{ height: 80, objectFit: "contain" }}
      />
      <CircularProgress size={32} thickness={4} sx={{ color: "#1A73E8" }} />
    </div>
  );
};

export default AppSplashScreen;
